import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';
import { format } from 'date-fns';

export const PerformanceCharts = () => {
  const { data: performanceData } = useQuery({
    queryKey: ['performance-metrics'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('performance_metrics')
        .select('*')
        .order('created_at', { ascending: true })
        .limit(50);

      if (error) throw error;

      return data.map(item => ({
        ...item,
        timestamp: format(new Date(item.created_at), 'HH:mm:ss'),
      }));
    },
    refetchInterval: 5000
  });

  return (
    <Card className="col-span-2">
      <CardHeader>
        <CardTitle>Métricas de Performance</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={performanceData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="timestamp" />
              <YAxis yAxisId="left" />
              <YAxis yAxisId="right" orientation="right" />
              <Tooltip />
              <Line
                yAxisId="left"
                type="monotone"
                dataKey="load_time_ms"
                stroke="#8884d8"
                name="Tempo de Carregamento (ms)"
              />
              <Line
                yAxisId="right"
                type="monotone"
                dataKey="memory_usage_mb"
                stroke="#82ca9d"
                name="Uso de Memória (MB)"
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};